/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import {Input, FormGroup, Col, Label, Alert} from 'reactstrap';
import Validator from '../../custom-classes/validator';
/** Multiple Language imports **/
import {Translate} from "react-localize-redux";
/** End of Multiple Language imports **/
import SelectorCountry from '../selectors/selector-country';
import SelectorState from '../selectors/selector-state';
import ApiCalls from '../../custom-classes/api-calls';

/**
 * Class to handle the address form group
 */
class FormGroupAddress extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        this.state =
        {
            validAddress: true,
            validCity: true,
            validState: true,
            validCountry: true,
            validZipCode: true,
            validPhone: true,
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: '',
            country: 'US', // Default
            zipCode: '',
            stateRequired: false
        }; // Default value

        if (this.props.data) {
            this.state =
            {
                validAddress: true,
                validCity: true,
                validState: true,
                validCountry: true,
                validZipCode: true,
                validPhone: true,
                addressLine1: this.props.data.addressLine1,
                addressLine2: this.props.data.addressLine2,
                city: this.props.data.city,
                state: this.props.data.state === null ? '' : this.props.data.state,
                country: this.props.data.country,
                zipCode: this.props.data.zipCode,
                stateRequired: false
            }; // Default value
        }

        this.handleAddressLine1Change = this.handleAddressLine1Change.bind(this);
        this.handleAddressLine2Change = this.handleAddressLine2Change.bind(this);
        this.handleCityChange = this.handleCityChange.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.handleZipCodeChange = this.handleZipCodeChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {

        if (typeof nextProps.data !== 'undefined') {
            this.setState({
                addressLine1: nextProps.data.addressLine1,
                addressLine2: nextProps.data.addressLine2,
                city: nextProps.data.city,
                state: nextProps.data.state === null ? '' : nextProps.data.state,
                country: nextProps.data.country, // Default
                zipCode: nextProps.data.zipCode,
                stateRequired: false
            });

        }
    }

    handleAddressLine1Change(event) {
        this.setState({addressLine1: event.target.value}, () => {
            // Check if address is valid
            this.setState({validAddress: Validator.isAddressValid(this.state.addressLine1)}, () => {
                this.setState({validCity: Validator.isCityValid(this.state.city)}, () => {
                        this.setState({validCountry: Validator.isCountryValid(this.state.country)}, () => {
                            this.setState(
                                {validZipCode: Validator.isZipCodeValid(this.state.zipCode)}, () => {
                                    this.props.updateParent(this.state);
                                    return this.state;
                                });
                        });
                });
            });
        });
        // This has a callback to evaluate the warning. If we don't use a callback, is not going to read the
        // last character while we are checking if they are equal or not
    }

    handleAddressLine2Change(event) {
        this.setState({addressLine2: event.target.value}, () => {
                this.props.updateParent(this.state);
                return this.state;
            }
        ); // This has a callback to evaluate the warning. If we don't use a callback, is not going to read the
        // last character while we are checking if they are equal or not
    }

    /**
     * Action when the city (address) change
     * @param event
     */
    handleCityChange(event) {
        this.setState({city: event.target.value}, () => {
                // Check if address is valid
                this.setState({validCity: Validator.isCityValid(this.state.city)}, () => {
                    this.props.updateParent(this.state);
                    return this.state;
                });
            }
        ); // This has a callback to evaluate the warning. If we don't use a callback, is not going to read the
        // last character while we are checking if they are equal or not
    }

    /**
     * Action when the state (address) change
     * @param event
     */
    handleStateChange(event) {
        this.setState({state: event.target.value}, () => {
                // Check if address is valid
                this.setState({validState: Validator.isStateValid(this.state.state)}, () => {
                    this.props.updateParent(this.state);
                    return this.state;
                });
            }
        ); // This has a callback to evaluate the warning. If we don't use a callback, is not going to read the
        // last character while we are checking if they are equal or not
    }

    /**
     * Handles when the country is changed
     * @param event
     */
    handleCountryChange(event) {

        this.setState({country: event.target.value}, () => {
                // Check if address is valid
                this.setState({validCountry: Validator.isCountryValid(this.state.country)}, () => {
                    this.props.updateParent(this.state);
                    return this.state;
                });
            }
        ); // This has a callback to evaluate the warning. If we don't use a callback, is not going to read the
        // last character while we are checking if they are equal or not
    }

    /**
     * Handles when the zip code is changed
     * @param event
     */
    handleZipCodeChange(event) {
        this.setState({zipCode: event.target.value}, () => {
                // Check if address is valid
                this.setState({validZipCode: Validator.isZipCodeValid(this.state.zipCode)}, () => {
                    this.props.updateParent(this.state);
                    return this.state;
                });
            }
        ); // This has a callback to evaluate the warning. If we don't use a callback, is not going to read the
        // last character while we are checking if they are equal or not
    }

    /**
     * Set the country selected
     * @param field
     */
    saveCountry = (field) => (newValue) => {

        if(newValue == null || newValue == "0")
        {
            this.setState({
                validState: true, stateRequired: false, state: '',
                validCountry: false,
                country: ''
            }, ()=>{
                this.props.updateParent(this.state);
                return this.state;
            })
        }

        if (newValue != null && newValue != "0") {
            // Check if country has states
            let apiCall = ApiCalls.getCountries(newValue);
            apiCall.then((data)=> {
                // If it doesn't have states
                if (!data.ResponseIsoModelList[0].HasStates) {
                    this.setState({
                        validState: true, stateRequired: false, state: '',
                        validCountry: Validator.isCountryValid(newValue),
                        country: newValue
                    }, ()=> {
                        this.props.updateParent(this.state);
                        return this.state;
                    });
                }
                else {
                    this.setState(
                        {
                            stateRequired: data.ResponseIsoModelList[0].HasStates,
                            validCountry: Validator.isCountryValid(newValue),
                            state: '',
                            validState: false,
                            country: newValue
                        },
                        ()=> {
                            this.props.updateParent(this.state);
                            return this.state;
                        });
                }
            });

        }
    };

    /**
     * Saves the state province when change
     * @param field
     */
    saveStateProvince = (field) => (newValue) => {
        this.setState({'state': newValue}, ()=> {
            this.setState({validState: Validator.isStateValid(this.state.state)}, () => {
                this.props.updateParent(this.state);
                return this.state;
            });
        });
    };

    // Render the form group
    render() {
        return (
            <div>
                <FormGroup row>
                    <Col sm={{size: 10, offset: 1}}>
                        <Label for="address">
                            <Translate id="register.address" options={{renderInnerHtml: true}}/>
                        </Label>
                        <Input value={this.state.addressLine1} type="text" name="address" id="address"
                               onChange={this.handleAddressLine1Change}/>
                    </Col>
                </FormGroup>
                {!this.state.validAddress ?
                    <FormGroup row>
                        <Col sm={{size: 10, offset: 1}}>
                            <Alert color="danger" isOpen={!this.state.validAddress}>
                                <Translate id="register.address-line-1-error"/>
                            </Alert>
                        </Col>
                    </FormGroup> : null
                }
                <FormGroup row>
                    <Col sm={{size: 10, offset: 1}}>
                        <Input value={this.state.addressLine2} type="text" name="address-line-2" id="address-line-2"
                               onChange={this.handleAddressLine2Change}/>
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Col sm={{size: 10, offset: 1}}>
                        <Label for="city">
                            <Translate id="register.city"/>
                        </Label>
                        <Input value={this.state.city} type="text" name="city" id="city"
                               onChange={this.handleCityChange}/>
                    </Col>
                </FormGroup>
                {!this.state.validCity ?
                    <FormGroup row>
                        <Col sm={{size: 10, offset: 1}}>
                            <Alert color="danger" isOpen={!this.state.validCity}>
                                <Translate id="register.city-error"/>
                            </Alert>
                        </Col>
                    </FormGroup> : null
                }
                <FormGroup row>
                    <Col sm={{size: 10, offset: 1}}>
                        <Label for="country">
                            <Translate id="register.country"/>
                        </Label>
                        <SelectorCountry data={this.state.country} value={this.state.country}
                                         updateParent={this.saveCountry("country")}/>
                    </Col>
                </FormGroup>
                {!this.state.validCountry ?
                    <FormGroup row>
                        <Col sm={{size: 10, offset: 1}}>
                            <Alert color="danger" isOpen={!this.state.validCountry}>
                                <Translate id="register.country-error"/>
                            </Alert>
                        </Col>
                    </FormGroup> : null
                }

                {this.state.stateRequired ?
                    <FormGroup row>
                        <Col sm={{size: 10, offset: 1}}>
                            <Label for="state">
                                <Translate id="register.state"/>
                            </Label>
                            <SelectorState data={this.state} value={this.state.state}
                                           updateParent={this.saveStateProvince("state")}/>
                        </Col>
                    </FormGroup> : null
                }
                {
                    !this.state.validState ?
                        <FormGroup row>
                            <Col sm={{size: 10, offset: 1}}>
                                <Alert color="danger" isOpen={!this.state.validState}>
                                    <Translate id="register.state-error"/>
                                </Alert>
                            </Col>
                        </FormGroup> : null
                }
                <FormGroup row>
                    <Col sm={{size: 10, offset: 1}}>
                        <Label for="zip-code">
                            <Translate id="register.zip-code"/>
                        </Label>
                        <Input value={this.state.zipCode}
                               type="text" name="zip-code" id="zip-code"
                               onChange={this.handleZipCodeChange}/>
                    </Col>
                </FormGroup>
                {!this.state.validZipCode ?
                    <FormGroup row>
                        <Col sm={{size: 10, offset: 1}}>
                            <Alert color="danger" isOpen={!this.state.validZipCode}>
                                <Translate id="register.zip-code-error"/>
                            </Alert>
                        </Col>
                    </FormGroup>
                    : null }
            </div>
        )
    };
}

export default FormGroupAddress;


// WEBPACK FOOTER //
// ./src/components/forms/form-group-address.js